import React from 'react';

import {
  X
} from 'react-feather'

const Popup = (props) => {

  const popupStyle = props.height || props.width ?
    { height: props.height + "px", width: props.width + "px", overflow: "auto" }
    : {};

  return props.trigger ? (
    <div className={`background-popup`}>
      <div className="popup-box">

        <div className="popup-inner" style={popupStyle}>

          <div className="popup-header">
            <span>{props.title}</span>

            <button onClick={() => props.setTrigger(false)}>
              <X size={20} />
            </button>
          </div>

          {props.children}

        </div>

      </div>

    </div>
  ) : ("");
}

export default Popup;